import React, { useState } from "react";
import Logo from "../Home/images/Logo.png";
import { FaBars } from "react-icons/fa";
import { ImCross } from "react-icons/im";

const Nav = () => {
  const [show, setShow] = useState(false);

  const toggleMenu = () => {
    setShow((prev) => !prev);
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-white shadow-md">
      {/* === Navbar Main === */}
      <div className="flex justify-between items-center px-4 py-3 sm:px-6 md:px-8 lg:px-10 h-16 md:h-20 lg:h-24">
        {/* Logo */}
        <div className="w-[150px] sm:w-[170px] md:w-[180px]">
          <img
            src={Logo}
            alt="Logo"
            className="w-full h-auto object-contain"
          />
        </div>

        {/* Desktop Links */}
        <div className="hidden lg:block">
          <ul className="flex items-center gap-8 text-gray-600 text-[15px] xl:text-[16px] font-medium cursor-pointer">
            <li className="hover:text-gray-900 transition">About Us</li>
            <li className="hover:text-gray-900 transition">Services</li>
            <li className="hover:text-gray-900 transition">Case Studies</li>
            <li className="hover:text-gray-900 transition">Blog</li>
            <li className="hover:text-gray-900 transition">How it Works</li>
            <li className="hover:text-gray-900 transition">Hire</li>
          </ul>
        </div>

        {/* Desktop Button */}
        <div className="hidden lg:block">
          <button className="bg-gray-800 hover:bg-gray-900 transition text-white font-medium w-[124px] h-[42px] rounded">
            Contact Us
          </button>
        </div>

        {/* Mobile Menu Icon */}
        <div className="lg:hidden flex items-center">
          {show ? (
            <ImCross
              onClick={toggleMenu}
              className="text-3xl sm:text-4xl text-gray-800 cursor-pointer"
            />
          ) : (
            <FaBars
              onClick={toggleMenu}
              className="text-3xl sm:text-4xl text-gray-800 cursor-pointer"
            />
          )}
        </div>
      </div>

      {/* === Mobile Menu === */}
      <div
        className={`lg:hidden fixed top-[64px] sm:top-[80px] left-0 w-full bg-white transition-all duration-300 ease-in-out overflow-hidden ${
          show ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <ul className="flex flex-col items-start gap-6 py-6 px-6 sm:px-10 text-gray-700 text-lg font-medium cursor-pointer">
          <li className="hover:text-gray-900 transition">About Us</li>
          <li className="hover:text-gray-900 transition">Services</li>
          <li className="hover:text-gray-900 transition">Case Studies</li>
          <li className="hover:text-gray-900 transition">Blog</li>
          <li className="hover:text-gray-900 transition">How it Works</li>
          <li className="hover:text-gray-900 transition">Hire</li>
          <li>
            <button className="mt-2 bg-gray-800 hover:bg-gray-900 transition text-white font-medium w-[124px] h-[42px] rounded">
              Contact Us
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Nav;
